module.exports = __webpack_public_path__ + "img/中国科学院-300x300.72c30130.jpg";